// Only load and initialize Faro in production (not dev, test, or Lighthouse/E2E runs on localhost).
// Dynamic imports keep the SDK out of the initial bundle — it's fetched only when this condition is met.
if (
  process.env.NODE_ENV !== "development" &&
  process.env.NEXT_PUBLIC_E2E_TEST !== "true" &&
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  !window.location.hostname.match(/^127\.\d+\.\d+\.\d+$/)
) {
  Promise.all([
    import("@grafana/faro-react"),
    import("@grafana/faro-web-tracing"),
  ]).then(
    ([
      { initializeFaro, ReactIntegration, getWebInstrumentations },
      { TracingInstrumentation },
    ]) => {
      initializeFaro({
        url: "https://faro-collector-prod-us-west-0.grafana.net/collect/22020db8551d76fc87565a8f49ce8f19",
        app: {
          name: "malott.dev client",
          version: "1.0.0",
          environment: "production",
        },
        sessionTracking: {
          samplingRate: 1,
          persistent: false,
        },

        instrumentations: [
          // Mandatory, omits default instrumentations otherwise.
          ...getWebInstrumentations(),

          // Tracing package to get end-to-end visibility for HTTP requests.
          // TracingInstrumentation includes DocumentLoadInstrumentation which
          // automatically parses the Server-Timing header set by proxy.ts
          // to link client document-load spans to server-side traces.
          // Also propagates W3C traceparent on all outgoing fetch/XHR requests.
          new TracingInstrumentation({
            instrumentationOptions: {
              propagateTraceHeaderCorsUrls: [/malott\.dev/],
            },
          }),

          // React integration for React applications (Next.js compatible).
          new ReactIntegration(),
        ],
      });
    }
  );
}
